<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-06-01 08:57:21
 * @LastEditors: WangYuan
 * @LastEditTime: 2021-09-26 15:18:52
-->
<template>
  <config-item v-show="isShow" :label='label'>

    <div>

      <el-select style="width: 100%" v-model="tagSource" size="small" @change="change">
        <el-option
            v-for="item in tagList"
            :label="item.name"
            :value="item.url"
        />
      </el-select>

      <!-- 选择分类 -->
      <div
          v-if="mValue.isShowClass && isShowListClass"
          class="flex mt20 mb10"
      >
        <div class="w120 f13 f-grey pl12 mr10 lh-28" style="margin-left:-100px;">选择分类</div>
        <el-button @click="showClassPopup" size="mini" type="primary"
        >
          {{mValue.selectClass&&mValue.selectClass?.length && mValue.selectClass.some(c => c[c.relationField]) ? '修改分类' : '选择分类'}}
        </el-button>
      </div>

      <el-dialog
          v-if="showClass"
          title="选择分类"
          :visible.sync="showClass"
          width="30%"
      >
        <el-tabs type="border-card">
          <el-tab-pane
              :label="item.title"
              v-for="(item, index) in dsInitParams"
              :key="index"
          >
            <div class="points-tit mb10">
              选择{{ item.title ? item.title : "" }}({{
                item.required ? "必填" : "非必填"
              }})
            </div>

            <div
                v-if="item.paramType != 'dict'"
                style="height: 400px; overflow-x: hidden; overflow-y: auto"
            >



              <el-tree
                  ref="tree"
                  :data="item.dataList"
                  show-checkbox
                  check-on-click-node
                  default-expand-all
                  :node-key="item.relationField"
                  highlight-current
                  max-height="500"
                  :props="{
                children: item.dataMapper.children.source,
                label: 'name',
              }"
                  @check="
                (node, checkedNode) =>
                  handleCheckChange(node, checkedNode, item, index)
              "
              >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div>
                  <i
                      :style="
                      treeSelect.includes(data[item.relationField])
                        ? 'color:#1684FC'
                        : ''
                    "
                      v-if="
                      data[item.dataMapper.children.source] &&
                      data[item.dataMapper.children.source].length > 0
                    "
                      class="el-icon-folder-opened mr10"
                  ></i>
                  <i
                      v-else
                      :style="
                      treeSelect.includes(data[item.relationField])
                        ? 'color:#1684FC'
                        : ''
                    "
                      class="el-icon-document mr10"
                  ></i>
                  <span
                      :style="
                      treeSelect.includes(data[item.relationField])
                        ? 'color:#1684FC'
                        : ''
                    "
                  >{{ node.label }}</span
                  >
                </div>
              </span>
              </el-tree>




            </div>

            <div v-else>
              <el-table
                  ref="insidTable"
                  :data="item.dataList"
                  :row-key="getRowKey"
                  class="insidTab"
                  size="mini"
                  stripe
                  max-height="500"
                  :show-header="false"
              >
                <el-table-column
                    align="center"
                    reserve-selection
                    type="selection"
                    width="55"
                >
                  <template slot-scope="scope">
                    <input
                        type="checkBox"
                        :checked="scope.row[item.relationField] == item.curChoose"
                        @click="
                      btnClickParams(index, scope.row[item.relationField])
                    "
                    />
                  </template>
                </el-table-column>

                <el-table-column
                    :label="items.targetName"
                    :prop="items.source"
                    class-name="custom-cell"
                    v-for="(items, indexs) in item.dataMapper"
                    :key="indexs"
                >
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div slot="footer">
          <el-button size="small" @click="showClass = false">取消</el-button>
          <el-button size="small" type="primary" @click="submit">确定</el-button>
        </div>
      </el-dialog>





    </div>

  </config-item>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";

import {
  getDatasourceList,
  getCategoryList,
  datasourcePage,
  getCategoryListPost,
  getDatasourceByDsId,
  getDatasourceByUrl,
} from "@/api/easyApp";



import {deepClone} from "../../../js/utils";
import {mapGetters} from "vuex";

export default {
  name: "SchemaTagSourceNew",
  mixins: [schemaMixin],
  props: {
    labelSwitch: {
      default: true,
    },
    isShow: {
      default: true,
    },
    tagCategory: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: {}
    }
  },

  inject: ['mode'],

  data() {
    return {
      tagSource: "",
      defaultOptions: {
        trueLabel: "显示",
        falseLabel: "隐藏",
      },
      tagList:[],
      valueNew:'',
      selectClass: [],
      treeSelect: [],
      dsInitParams: [],
      paramsSelectList: [],
      loadParamsData: false,
      showClass: false,

    };
  },
  computed: {
    ...mapGetters(["project"]),
    isShowListClass() {
      if (this.tagList && this.tagSource) {
        let table_index = this.tagList.findIndex(
            (item) => item.url == this.tagSource,
        );
        if (
            this.tagList[table_index].relationParams ||
            this.tagList[table_index].params
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },

  /*  watch: {
      valueNew: {
        immediate: true,
        deep:true,
        handler(newVal,oldVal) {
          //this.value = this.valueNew;
        },
      },
    },*/

  async created() {
    let data={
      tags:this.tagCategory
    }

    let res=await getDatasourceList(data);
    this.tagList=res.data;



    if (this.mValue.tagSource) {

      let index = this.tagList.findIndex((item) => item.url == this.mValue.tagSource);
      if (index != -1) {

        let configContent = JSON.parse(this.tagList[index].dataMapperList[0].configContent);


        if (!Array.isArray(configContent)) {
          let configContentNew = [];
          let paramsData=[];
          if(configContent.paramsData){
            for(let i in configContent.paramsData){
              paramsData.push({ target: i, ...configContent.paramsData[i] })
            }
            this.mValue.paramsData = deepClone(paramsData);
          }
          else{
            this.mValue.paramsData =[];
          }

          for (const i in configContent) {
            if(i!='paramsData'){
              let obj = configContent[i];
              obj['target'] = i;
              obj['targetName'] = configContent[i].sourceName;
              configContentNew.push(obj);
            }

          }

          this.mValue.dataMapper = deepClone(configContentNew);

          if (this.mValue.isSupportSearch == true) {
            let index = this.mValue.dataMapper.findIndex((item) => item.target == 'keyword');

            if (index != -1) {
              this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
            }

          }


        }
        else {

          this.mValue.dataMapper = deepClone(configContent);

          if (this.mValue.isSupportSearch == true) {
            let index = this.mValue.dataMapper.findIndex((item) => item.target == 'keyword');

            if (index != -1) {
              this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
            }
          }



        }

      }
    }
    else {
      this.mValue.tagSource = this.tagList[0].url;
      let configContent = JSON.parse(this.tagList[0].dataMapperList[0].configContent);
      if (!Array.isArray(configContent)) {

        let configContentNew = [];
        let paramsData=[];
        if(configContent.paramsData){
          for(let i in configContent.paramsData){
            paramsData.push({ target: i, ...configContent.paramsData[i] })
          }
          this.mValue.paramsData = deepClone(paramsData);
        }
        else{
          this.mValue.paramsData =[];
        }

        for (const i in configContent) {

          if(i!='paramsData'){
            let obj = configContent[i];
            obj['target'] = i;
            obj['targetName'] = configContent[i].sourceName;
            configContentNew.push(obj);
          }


        }

        this.mValue.dataMapper = deepClone(configContentNew);

        if (this.mValue.isSupportSearch == true) {
          let index = this.mValue.dataMapper.findIndex((item) => item.target == 'keyword');

          if (index != -1) {
            this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
          }
        }





      }
      else {
        this.mValue.dataMapper = deepClone(configContent);


        if (this.mValue.isSupportSearch == true) {
          let index = this.mValue.dataMapper.findIndex((item) => item.target == 'keyword');

          if (index != -1) {
            this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
          }
        }


      }

    }

    this.tagSource = this.mValue.tagSource.split("?")[0];

  },
  methods: {

    change(val) {
      console.log("val:",val,this.mValue.tagSource);


      let index = this.tagList.findIndex((item) => item.url == val);
      if (index != -1) {

        if(this.mValue.tagSource.split("?")[0]!=val&&this.mValue.isShowClass){
           this.selectClass=[];
         this.mValue.selectClass=[];
          this.tagSource =val;
          this.mValue.tagSource=val;
        }
        else{
          this.tagSource =val;
          this.mValue.tagSource=val;
        }


        // this.mValue.dataMapper = JSON.parse(this.tagList[index].dataMapperList[0].configContent);

        let configContent = JSON.parse(this.tagList[index].dataMapperList[0].configContent);

        if (!Array.isArray(configContent)) {

          let configContentNew = [];
          let paramsData=[];
          if(configContent.paramsData){
            for(let i in configContent.paramsData){
              paramsData.push({ target: i, ...configContent.paramsData[i] })
            }
            this.mValue.paramsData = deepClone(paramsData);
          }
          else{
            this.mValue.paramsData =[];
          }

          for (const i in configContent) {
            if(i!='paramsData'){
              let obj = configContent[i];
              obj['target'] = i;
              obj['targetName'] = configContent[i].sourceName;
              configContentNew.push(obj);
            }

          }

          this.mValue.dataMapper = deepClone(configContentNew);

          if (this.mValue.isSupportSearch == true) {
            let index = this.mValue.dataMapper.findIndex((item) => item.target == 'keyword');

            if (index != -1) {
              this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
            }

          }



        }
        else{
          this.mValue.dataMapper = JSON.parse(this.tagList[index].dataMapperList[0].configContent);


          if (this.mValue.isSupportSearch == true) {
            let index = this.mValue.dataMapper.findIndex((item) => item.target == 'keyword');

            if (index != -1) {
              this.mValue.realSearchSign = this.mValue.dataMapper[index].source;
            }
          }



        }


        this.$forceUpdate();
      } else {
      }
    },
    //展示弹窗
    async showClassPopup() {
      this.checkObjs = [];
      this.dataMapper = [];

      //前置数据源
      let code = [];
      //列表数据
      let initList = [];
      //字段数据
      let initDictList = [];
      //新旧

      // try {
      let table_index = this.tagList.findIndex(
          (item) => item.url == this.tagSource,
      );
      let relationParams = null;
      let ds_Name = null;
      let ds_Field = null;
      let dict_Ds = null;

      if (this.tagList[table_index].params) {
        relationParams = JSON.parse(this.tagList[table_index].params);
        ds_Name = "dsName";
        ds_Field = "dsField";
        dict_Ds = "dictDs";
      } else if (this.tagList[table_index].relationParams) {
        relationParams = JSON.parse(this.tagList[table_index].relationParams);
        ds_Name = "relationDS";
        ds_Field = "relationField";
        dict_Ds = "dictDS";
      } else {
        this.$message({ message: "未查询到分类", type: "error" });
        return false;
      }

      //字典数据
      let dict = relationParams.filter((item) => item.paramType == "dict");

      //列表数据
      let normalParams = relationParams.filter(
          (item) => item.paramType != "dict",
      );

      normalParams.forEach((item) => {
        code.push(item[ds_Name]);
        let dataMapper = [];
        let index = this.tagList.findIndex(
            (item2) => item2.url == this.tagSource,
        );

        if (index != -1) {
          dataMapper = this.tagList[index].dataMapperList[0]["configContent"];
          dataMapper = JSON.parse(dataMapper);
          let obj = {
            code: item[ds_Name],
            dataMapper: dataMapper,
            name: item["name"], //传递的
            relationField: item[ds_Field], //勾选的
            dataList: [],
            required: item.required,
            multiValue: item.multiValue,
            concatType: item.concatType,
            concatChar: item.concatChar,
            paramType: item.paramType,
            title: "",
          };
          initList.push(obj);
        }
      });
      dict.forEach((item) => {
        initDictList.push({
          dataMapper: {
            label: {
              source: "label",
              sourceName: item[dict_Ds].name,
            },
          },
          name: item.name,
          relationField: "value",
          dataList: JSON.parse(item[dict_Ds].items),
          title: item[dict_Ds].name,
          paramType: item.paramType,
          required: item.required,
          curChoose: "",
        });
      });

      let data = {
        codes: code.toString(),
        current: 1,
        size: 100,
      };
      let res = await datasourcePage(data);
      let records = res.data.records;
      if (records && records.length > 0) {
        for (const i in initList) {
          let obj = {
            current: 1,
            size: 10,
            dataList: [],
            pages: 0,
            code: records[i].code,
            total: 0,
          };

          let result = await this.getInitData(
              obj,
              records[i].url,
              records[i].method,
          );
          initList[i].dataList = result;
          initList[i].showType = records[i].showType;
          initList[i].title = records[i].name;
        }
      }

      if (initDictList.length > 0) {
        this.dsInitParams = [...initList, ...initDictList];
      } else {
        this.dsInitParams = initList;
      }
      console.log("11111111:",this.dsInitParams);

      this.showClass = true;

      this.$nextTick(() => {

        this.mValue.selectClass.forEach((item, index) => {
          if (item.paramType == "dict") {
            this.dsInitParams.forEach((item2, index2) => {
              if (item2.name == item.name) {
                this.dsInitParams[index2].curChoose = item[item.relationField];
              }
            });
          } else {
            this.dsInitParams.forEach((item2, index2) => {
              if (item2.showType == "show_tree") {
                let arr = item[item.relationField].split(",");
                this.$refs.tree[index2].setCheckedKeys(arr);
              }
            });
          }
        });

        this.selectClass = this.mValue.selectClass;
      });




    },

    //获取前置数据源分类
    async getInitData(obj, url, method) {
      if (method == "post" || method == "POST") {
        let data = {
          current: obj.current,
          size: obj.size,
          url: url,
        };

        let res = await getCategoryListPost(data);

        return res.data;
      } else if (method == "get" || method == "GET") {
        let data = {
          current: obj.current,
          size: obj.size,
          url: url,
        };

        let res = await getCategoryList(data);
        return res.data;
      }
    },

    //树形图选择
    handleCheckChange(data, checkedNode, item, index) {
      //多选
      if (item && item.multiValue) {
        let id = "";
        if (item.concatType == "CONCAT") {
          id = checkedNode.checkedKeys.join(item.concatChar);
        } else {
          //数组
          id = JSON.stringify(checkedNode.checkedKeys);
        }
        this.treeSelect = checkedNode.checkedKeys;
        this.btnClickParams(index, id);
      } else {
        //单选
        this.$refs.tree[index].setCheckedKeys([data[item.relationField]]);
        this.btnClickParams(index, data[item.relationField]);
        this.treeSelect = [data[item.relationField]];
      }
    },

    //其他选择
    btnClickParams(index, id) {
      console.log(index, id);
      console.log(this.dsInitParams);
      const componentId = this.dsInitParams[index].name;
      let index1 = -1;
      if (this.selectClass) {
        index1 = this.selectClass.findIndex(
            (item) => item.componentId == componentId,
        );
      } else {
        this.selectClass = [];
      }

      this.dsInitParams[index].curChoose = id;
      const obj = {
        componentId: this.dsInitParams[index].name,
        relationField: this.dsInitParams[index].relationField, //前置
        name: this.dsInitParams[index].name, //接收
        paramType: this.dsInitParams[index].paramType,
        showType: this.dsInitParams[index].showType,
      };
      obj[this.dsInitParams[index].relationField] = id;

      if (index1 != -1) {
        this.selectClass[index1] = deepClone(obj);
      } else {

        if(this.dsInitParams[index].showType=='show_tree'){
          this.selectClass=[obj];
        }
        else{
          this.selectClass.push(obj);
        }

      }



      console.log(this.selectClass);
    },

    //提交
    submit() {
      let url = this.tagSource;
      this.selectClass.forEach((item, index) => {
        if (index == 0) {
          url += "?" + item.name + "=" + item[item.relationField];
        } else {
          url += "&" + item.name + "=" + item[item.relationField];
        }
      });
      this.mValue.selectClass = this.selectClass;

      this.mValue.tagSource = url;
      this.showClass = false;
    },

  }


};
</script>

<style lang="scss" scoped>
.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 25px; /*no*/

  .wrap-label {
    font-size: 14px; /*no*/
    line-height: 32px; /*no*/
  }
}
</style>